<div class="mobi-ui-wrapper">
    <div class="mobi-ui-wrapper-content">
        <app-header [title]=""></app-header>
        <router-outlet></router-outlet>
    </div>
    <app-footer></app-footer>
</div>
